export default {
  version: 'master',
  compilation: '304246'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22